

export async function shopifyGraphQLRequest(query, variables = {}) {
  const shopifyDomain = localStorage.getItem('shopDomain');
  const shopifyAccessToken = localStorage.getItem('shopToken');
  const shopifyVersion = '2025-01';
  const endpoint = `https://${shopifyDomain}/api/${shopifyVersion}/graphql.json`;

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': shopifyAccessToken,
    },
    body: JSON.stringify({ query, variables }),
  });

  const { data, errors } = await response.json();
  if (errors) {
    console.error('Shopify GraphQL errors:', errors);
    throw new Error('Shopify GraphQL request failed');
  }

  return data;
}
